module.exports = {
  TRELLO_FOR_TEAMS: [
    '5c3e2f4db4f88f385d26e2cb', # weekly team meetings
    '5c3e2f948af0c952c092ce40', # team goal setting central
    '5c3e2fdb0fa92e43b849d838', # project management
    '5c3e2ec871be6643f85f448b', # office party planning
    '5c3e30722972c101885955fb', # team organization central
    '5c4ef5e4bbacaa446b3993f5', # pt-br boards
    '5c4ef605d38e27452f525bb4',
    '5c4ef615717f047b64dcda5f',
    '5c4ef6244089b88c06bd9f2c',
    '5c4ef632f53e7e77a5422e17',
    '5c4ef7d76e9fd58768352e98', # es boards
    '5c4ef811575a7549999ca501',
    '5c4ef7ee1223fd25d26a7afc',
    '5c4ef7ff1c45086cbf4cad82',
    '5c4ef827083f7087b1773560',
    '5c4ef939923d1671db0ba579', # de boards
    '5c4ef94d8688de70c5782029',
    '5c4ef95f186e711c943d34a0',
    '5c4ef97089bbae57347596f8',
    '5c4ef986b313348b53cd43e5',
    '5c4efa02233fb46cb98f8f22', # fr boards
    '5c4efa0e586cd43c34b60ec4',
    '5c4efa1d25a9692173830e7f',
    '5c4efa2bdcbd2f60958b4b8a',
    '5c4efa391176cd259be508cd'
  ]
  CAMPING: ['5a26bae36c0e623f622121f9']
}



// WEBPACK FOOTER //
// ./app/scripts/data/marketing-campaign-boards.coffee